exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-panel-toggle{cursor:pointer}", ""]);
